import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { authAPI } from '../services/api';

function StudentLogin({ onLogin }) {
    const [formData, setFormData] = useState({
        email: '',
        password: '',
    });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await authAPI.login(formData.email, formData.password);

            if (response.data.user.role !== 'student') {
                toast.error('Access denied. Student only.');
                setLoading(false);
                return;
            }

            toast.success('Login successful!');
            onLogin(response.data.user, response.data.token);
        } catch (error) {
            toast.error(error.response?.data?.message || 'Login failed');
            setLoading(false);
        }
    };

    return (
        <div className="login-page">
            <div className="login-container">
                <div className="login-card">
                    <div className="text-center mb-4">
                        <h1 className="brand-title">Novantix Innovation <br /> Technology</h1>
                        <p className="brand-subtitle">Industry-Ready Skills • Real-World Projects • Certification</p>
                    </div>

                    <div className="welcome-section">
                        <h2>Welcome Back!</h2>
                        <p>Login to access your student portal</p>
                    </div>

                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label htmlFor="email">Email Address</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                placeholder="hellonsp1919@gmail.com"
                                className="form-control"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="password">Password</label>
                            <input
                                type="password"
                                id="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                required
                                placeholder="Enter your password"
                                className="form-control"
                            />
                        </div>

                        <div className="form-group checkbox-group">
                            <input type="checkbox" id="remember" />
                            <label htmlFor="remember">Remember me</label>
                        </div>

                        <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
                            {loading ? 'Logging in...' : 'Login to Portal'}
                        </button>
                    </form>

                    <div className="divider">
                        <span>or</span>
                    </div>

                    <div className="login-footer">
                        <p>Don't have an account? <button className="btn-link" style={{ border: 'none', cursor: 'pointer', fontSize: 'inherit', textDecoration: 'none' }} onClick={() => window.location.href = 'mailto:info@novantix.com'}>Contact Us to Enroll</button></p>
                        <a href="/" className="back-link">← Back to Home</a>
                    </div>
                </div>
            </div>
        </div>
    );

}

export default StudentLogin;
